import template from './already-subscribed-notification.tpl.pug';

class AlreadySubscribedController {
    close() {
        return this.onClose();
    }
}

export default {
    selector: 'dbAAlreadySubscribedNotification',
    template: template(),
    controller: AlreadySubscribedController,
    bindings: {
        onClose: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/notifications/component/already-subscribed-notification/already-subscribed-notification.cmpt.js